/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Fix for add to cart button issues
  document.addEventListener('DOMContentLoaded', function() {
    // Try multiple selectors to find the form
    let productForm = document.querySelector('product-form form[id*="ProductForm"]');

    if (!productForm) {
      productForm = document.querySelector('form[id*="ProductForm"]');
    }

    if (!productForm) {
      productForm = document.querySelector('[data-product-form]');
    }

    if (!productForm) {
      productForm = document.querySelector('product-form');
    }

    if (productForm) {

      // Variable to track if submission is in progress
      let isSubmitting = false;
      let submissionCount = 0;

      // Intercept form submission
      productForm.addEventListener('submit', function(e) {
        submissionCount++;

        // Prevent double submission
        if (isSubmitting) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }

        const addButton = this.querySelector('[data-add-to-cart]') || this.querySelector('#AddToCart--template--24624909517101__main');

        if (addButton) {
          isSubmitting = true;

          // Store original state
          const originalText = addButton.querySelector('[data-add-to-cart-text]')?.textContent || 'Add to cart';

          // Add loading state
          addButton.classList.add('is-loading');
          addButton.setAttribute('disabled', 'disabled');

          // Set a timeout to restore button after 2 seconds
          setTimeout(function() {
            addButton.classList.remove('is-loading');
            addButton.removeAttribute('disabled');
            isSubmitting = false;
            submissionCount = 0;

            // Restore text if needed
            const textElement = addButton.querySelector('[data-add-to-cart-text]');
            if (textElement && !textElement.textContent) {
              textElement.textContent = originalText;
            }
          }, 2000);
        }
      }, true); // Use capture phase

      // Listen for all possible cart events
      const cartEvents = [
        'theme:cart:change',
        'cart:change',
        'cart:update',
        'cart:added',
        'theme:cart:added',
        'theme:product:add',
        'theme:product:added',
        'ajaxCart:added',
        'cart:refresh'
      ];

      cartEvents.forEach(eventName => {
        document.addEventListener(eventName, function() {
          const addButton = productForm.querySelector('[data-add-to-cart]') || productForm.querySelector('#AddToCart--template--24624909517101__main');
          if (addButton) {
            setTimeout(function() {
              addButton.classList.remove('is-loading');
              addButton.removeAttribute('disabled');
              isSubmitting = false;
              submissionCount = 0;

              // Restore text
              const textElement = addButton.querySelector('[data-add-to-cart-text]');
              if (textElement && !textElement.textContent) {
                textElement.textContent = 'Add to cart';
              }
            }, 500);
          }
        });
      });

      // Listen for error events
      document.addEventListener('theme:product:add-error', function() {
        const addButton = productForm.querySelector('[data-add-to-cart]') || productForm.querySelector('#AddToCart--template--24624909517101__main');
        if (addButton) {
          addButton.classList.remove('is-loading');
          addButton.removeAttribute('disabled');
          isSubmitting = false;
          submissionCount = 0;
        }
      });

      // Also try intercepting the button click directly
      const addButton = productForm.querySelector('[data-add-to-cart]') || productForm.querySelector('#AddToCart--template--24624909517101__main');
      if (addButton) {
        let clickIsSubmitting = false;

        addButton.addEventListener('click', function(e) {
          if (clickIsSubmitting) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }

          // Since Monster Upsells intercepts, handle button state here
          clickIsSubmitting = true;

          // Store original text
          const originalText = addButton.querySelector('[data-add-to-cart-text]')?.textContent || 'Add to cart';

          // Add loading state immediately
          addButton.classList.add('is-loading');
          addButton.setAttribute('disabled', 'disabled');

          // Reset after timeout
          setTimeout(function() {
            addButton.classList.remove('is-loading');
            addButton.removeAttribute('disabled');
            clickIsSubmitting = false;

            // Restore text
            const textElement = addButton.querySelector('[data-add-to-cart-text]');
            if (textElement && (!textElement.textContent || textElement.textContent.trim() === '')) {
              textElement.textContent = originalText;
            }
          }, 2500);
        }, true); // Use capture phase
      }
    }
  });

  // Monitor button state and fix it if it gets stuck
  setInterval(function() {
    const addButton = document.querySelector('[data-add-to-cart]');
    if (addButton && addButton.classList.contains('is-loading')) {
      // Check if it's been stuck for too long
      if (!addButton.hasAttribute('data-loading-timestamp')) {
        addButton.setAttribute('data-loading-timestamp', Date.now());
      } else {
        const timestamp = parseInt(addButton.getAttribute('data-loading-timestamp'));
        const elapsed = Date.now() - timestamp;

        // If button has been loading for more than 3 seconds, restore it
        if (elapsed > 3000) {
          addButton.classList.remove('is-loading');
          addButton.removeAttribute('disabled');
          addButton.removeAttribute('data-loading-timestamp');

          // Restore text
          const textElement = addButton.querySelector('[data-add-to-cart-text]');
          if (textElement && (!textElement.textContent || textElement.textContent.trim() === '')) {
            textElement.textContent = 'Add to cart';
          }
        }
      }
    } else if (addButton && addButton.hasAttribute('data-loading-timestamp')) {
      // Button is no longer loading, remove timestamp
      addButton.removeAttribute('data-loading-timestamp');
    }
  }, 500); // Check every 500ms






  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
